export class CmsContactUsProperties {
  contactUsID: number;
  title: string = "";
  images: string = "";
  description: string = "";
  logo: string = "";
  map: string = "";
}
export class NewsAlertProperties {
  newsId: string;
  newsDescription: string;
  newsLink: string;
  status: boolean;
}
export class NotificationProperties {
  notiId: string;
  notiDescription: string;
  status: boolean;
}
export class CmsContactUsFormProperties {

  firstName: string = "";
  lastName: string = "";
  emailUser: string = "";
  message: string = "";
}
